import type { UscSettingsType } from "../reducers/UscSettingsReducer";

export const USC_SETTINGS_INIT = "uscSettings/init";
export const USC_SETTINGS_SET_SHOW_SIMILAR_CARS = "uscSettings/setShowSimilarCars";
export const USC_SETTINGS_OVERRIDE = "uscSettings/override";

type InitUscSettings = {
    type: typeof USC_SETTINGS_INIT;
    initState: UscSettingsType;
};
export const initUscSettings = (initState: UscSettingsType): InitUscSettings => ({
    type: USC_SETTINGS_INIT,
    initState,
});

type setShowSimilarCars = {
    type: typeof USC_SETTINGS_SET_SHOW_SIMILAR_CARS;
    show: boolean;
};
export const setShowSimilarCars = (show: boolean): setShowSimilarCars => ({
    type: USC_SETTINGS_SET_SHOW_SIMILAR_CARS,
    show,
});

type OverrideableSettings = Partial<Pick<UscSettingsType, "onRetailerSite" | "landingPageUrl" | "detailPageUrl">>;
type OverrideUscSettings = {
    type: typeof USC_SETTINGS_OVERRIDE;
    override: OverrideableSettings;
};
export const overrideUscSettings = (override: OverrideableSettings): OverrideUscSettings => ({
    type: USC_SETTINGS_OVERRIDE,
    override,
});

export type UscSettingsActionsType = InitUscSettings | setShowSimilarCars | OverrideUscSettings;
